import gql from 'graphql-tag'

import { UserFieldsFragment } from 'main/gql/user'

export const SUBMIT_FINAL_PARENT_SIGN_UP_FORM_MUTATION = gql`
  mutation SubmitFinalParentSignUpForm($user: UpdateUserParams!) {
    updateUser(user: $user) {
      ...UserFields
    }
  }

  ${UserFieldsFragment}
`
